// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KGFL","col":"styles_col__2pLDQ","actions":"styles_actions__3Kceo","conflict":"styles_conflict__3rWkh"};